var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lf ks_left",attrs:{"id":"model"}},[_c('h1',[_vm._v("培训管理系统")]),_vm._v(" "),_c('ul',_vm._l((_vm.navTo.operate),function(operate,path,index){return _c('li',{key:index},[_c('router-link',{attrs:{"to":{ path: operate.path }}},[_vm._v("\n        "+_vm._s(operate.name)+"\n      ")])],1)}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11526a69","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Common/comheader.vue
// module id = null
// module chunks = 